import axios from "axios";

// const
const APPLICATION_CATEGORY_UPDATE_DATA = "applicationCategory/APPLICATION_CATEGORY_UPDATE_DATA";
const APPLICATION_CATEGORY_STORE_APPLICATION_CATEGORIES = "applicationCategory/APPLICATION_CATEGORY_STORE_APPLICATION_CATEGORIES";
const APPLICATION_CATEGORY_TOGGLE_MODAL = "applicationCategory/APPLICATION_CATEGORY_TOGGLE_MODAL";
const APPLICATION_CATEGORY_TOGGLE_LOADING = "applicationCategory/APPLICATION_CATEGORY_TOGGLE_LOADING";

const APPLICATION_CATEGORY_MODAL_SUCCESS_TITLE = "scenes_Algorithm_AlgorithmCategory_modal_success_title";
const APPLICATION_CATEGORY_MODAL_FAIL_TITLE = "scenes_Algorithm_AlgorithmCategory_modal_fail_title";
const APPLICATION_CATEGORY_MODAL_SAVE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_saveSuccess_content";
const APPLICATION_CATEGORY_MODAL_SAVE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_saveFail_content";
const APPLICATION_CATEGORY_MODAL_DELETE_SUCCESS_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_deleteSuccess_content";
const APPLICATION_CATEGORY_MODAL_DELETE_FAIL_CONTENT = "scenes_Algorithm_AlgorithmCategory_modal_deleteFail_content";
const APPLICATION_CATEGORY_MODAL_OK_LABEL = "scenes_Algorithm_AlgorithmCategory_modal_OK_label";
const APPLICATION_CATEGORY_MODAL_CANCEL_LABEL = "scenes_Algorithm_AlgorithmCategory_modal_cancel_label";

// reducer
export const applicationCategory = (state = {

  loading: false,
  visibleLogo: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  categoryId: "",
  isLeaf: "",

  previewLogo: "",
  logo: "",
  logoImage: [],
  code: "",
  codeExist: false,
  name: "",
  description: "",
  initApplicationCategories: [],
  applicationCategories: [],
}, action) => {
  switch (action.type) {
    case APPLICATION_CATEGORY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_CATEGORY_STORE_APPLICATION_CATEGORIES:
      return {
        ...state,
        applicationCategories: action.data,
        initApplicationCategories: action.data
      };
    case APPLICATION_CATEGORY_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case APPLICATION_CATEGORY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateApplicationCategoryData = (data) => {
  return {
    type: APPLICATION_CATEGORY_UPDATE_DATA,
    data: data
  }
};

/**
 * get all application categories
 */
export const getApplicationCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getApplicationCategoryTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplicationCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all application  categories
 */
export const storeApplicationCategories = (applicationCategories) => {
  return {
    type: APPLICATION_CATEGORY_STORE_APPLICATION_CATEGORIES,
    data: applicationCategories
  }
};

/**
 * submit data
 */
export const submitApplicationCategory = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "post",
    url: "/api-application/updateApplicationCategory",
    contentType: "application/json",
    withCredentials: true,
    data: data.applicationCategories,
  }).then(
    response => {
      if (response.status === 200) {
        console.log("success update applicationCategory");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_CATEGORY_MODAL_SUCCESS_TITLE,
          modalContent: APPLICATION_CATEGORY_MODAL_SAVE_SUCCESS_CONTENT,
          modalOk: APPLICATION_CATEGORY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getApplicationCategories());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getApplicationCategories());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        console.log("fail to update new applicationCategory");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_CATEGORY_MODAL_FAIL_TITLE,
          modalContent: APPLICATION_CATEGORY_MODAL_SAVE_FAIL_CONTENT,
          modalOk: APPLICATION_CATEGORY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
      dispatch(toggleLoading(false));
    }
  )
};

const loop = (data, key, callback) => {
  data.forEach((item, index, arr) => {
    if (item.key === key) {
      return callback(item, index, arr);
    }
    if (item.children) {
      return loop(item.children, key, callback);
    }
  });
};

/**
 * delete data
 */
export const deleteApplicationCategory = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "put",
    url: `/api-application/deleteApplicationCategory/${data.categoryId}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      if (response.status === 200) {
        console.log("success delete applicationCategory");
        const d = data.applicationCategories;
        loop(d, data.categoryId, (item, index, arr) => {
            arr.splice(index, 1);
            dispatch(updateApplicationCategoryData({
              name: "applicationCategories",
              value: d
            }));
            dispatch(updateApplicationCategoryData({
              name: "categoryId",
              value: ""
            }));
          }
        );
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_CATEGORY_MODAL_SUCCESS_TITLE,
          modalContent: APPLICATION_CATEGORY_MODAL_DELETE_SUCCESS_CONTENT,
          modalOk: APPLICATION_CATEGORY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        console.log("fail to delete new applicationCategory");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_CATEGORY_MODAL_FAIL_TITLE,
          modalContent: APPLICATION_CATEGORY_MODAL_DELETE_FAIL_CONTENT,
          modalOk: APPLICATION_CATEGORY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_CATEGORY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
      dispatch(toggleLoading(false));
    }
  )
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: APPLICATION_CATEGORY_TOGGLE_MODAL,
    data: show
  }
};
/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_CATEGORY_TOGGLE_LOADING,
    data: show
  }
};
